import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
  Calendar,
  BadgeCheck,
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About ICAN-2025",
    date: "25th - 27th Nov 2025",
    organizer: "Helix Conferences",
    description: [
      <>
        ICAN 2025, the International Conference on Autism & Neuropsychiatry,
        is a Globally recognized event spotlighting advancements in Neurological
        and Behavioral sciences. As one of the most awaited{" "}
        <Link
          to="https://autism.helixconferences.com/"
          target="blank"
          rel="noopener noreferrer"
          className="text-accent font-bold"
        >
          2025 Autism Conferences
        </Link>{" "}
        and among the leading Global Neuroscience Events, ICAN 2025 fosters a
        Global platform where Experts from across disciplines converge to share
        knowledge, practices, and patient-centric solutions.
      </>,
      <>
        This Global Autism Summit brings together Neurologists and
        psychiatrists, Autism Researchers and Therapists, Pediatricians,
        educators, and caregivers, Public health Leaders and policy makers. With
        topics spanning neuroimaging, early detection, genetic markers,
        cognitive therapies, behavioral interventions, and integrative support,
        ICAN 2025 promises transformative dialogues and collaborative
        opportunities.
      </>,
    ],
  },

  whyAttend: [
    "Attending ICAN 2025 offers unmatched opportunities for growth and global exposure in the field of autism and neuropsychiatry.",
    "Connect with world-class researchers and experts showcasing groundbreaking insights in neurological sciences.",
    "Engage with healthcare leaders and policymakers shaping the future of autism care globally.",
    "Gain actionable knowledge on early detection, behavioral interventions, and therapeutic innovation.",
    "Be part of a movement focused on shaping the next era of neuropsychiatric care and support.",
  ],

  aboutHelix: [
    "Helix Conferences has earned international recognition for organizing premium healthcare and neuroscience events. We design our conferences with a focus on strategic insights, research trends, and scientific breakthroughs to ensure attendees leave with real-world knowledge and partnerships.",
  ],

  whoShouldAttend: [
    "Neurologists and psychiatrists",
    "Autism Researchers and Therapists",
    "Pediatricians, educators, and caregivers",
    "Public health Leaders and policy makers",
    "Students and early-career professionals in neuroscience",
  ],

  join: [
    "Join us at ICAN 2025 to experience the fusion of science, strategy, and solution-driven innovation in autism and neuropsychiatry. Be part of the conversations that are transforming diagnosis, treatment, and support for neurodivergent individuals.",
  ],

  themes: [
    {
      icon: Brain,
      title: "Neurology",
      description:
        "Exploring Genetic Research: Foundations and Frontiers in Neurology",
    },
    {
      icon: HeartPulse,
      title: "Behavioral Science",
      description:
        "Innovations in Behavioral Interventions and Support Systems",
    },
    {
      icon: SmilePlus,
      title: "Early Detection",
      description:
        "Advancements in Early Diagnosis and Intervention Strategies",
    },
    {
      icon: Dna,
      title: "Genetic Research",
      description: "Understanding Genetic Markers in Autism Spectrum Disorders",
    },
    {
      icon: Video,
      title: "Therapeutic Approaches",
      description: "Modern Therapeutic Interventions in Autism Care",
    },
    {
      icon: Globe,
      title: "Global Perspectives",
      description: "International Approaches to Autism Care and Support",
    },
    {
      icon: Biohazard,
      title: "Research Ethics",
      description: "Ethical Considerations in Autism Research",
    },
    {
      icon: Radiation,
      title: "Technology Integration",
      description: "Innovative Technologies in Autism Support",
    },
  ],

  highlights: [
    {
      title: "Keynote Speakers",
      description: "Leading experts share breakthrough insights",
    },
    {
      title: "Panel Discussions",
      description: "Debates on autism care and policy",
    },
    {
      title: "Research Presentations",
      description: "Latest findings in autism research",
    },
    {
      title: "Workshop Sessions",
      description: "Hands-on training in therapeutic approaches",
    },
    {
      title: "Poster Presentations",
      description: "Research findings and clinical studies",
    },
    {
      title: "Networking Forums",
      description: "Connect with professionals and researchers",
    },
    {
      title: "Exhibition Zone",
      description: "Latest tools and technologies in autism care",
    },
    {
      title: "Awards & Recognition",
      description: "Honor excellence in autism research and care",
    },
  ],

  dates: {
    eventDate: "25th-27th Nov 2025",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "1st Nov 2025",
  },
};

const AboutPublicHealth = () => {
  return (
    <div className="w-full 2xl:max-w-[1280px] mx-auto justify-center items-center text-center">
      <div className={`${banner_style} w-full mx-auto about-banner`}>
        <h1 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h1>
      </div>

      <h1 className="text-4xl mt-2 font-bold text-one">
        ICAN 2025 – Empowering Global Dialogue in Autism & Brain Health
      </h1>
      <p className="text-center text-gray-600 text-3xl mb-6">
        <strong>
          10<sup>th</sup> Oct 2025
        </strong>
      </p>

      {data.event.description.map((desc, idx) => (
        <p
          key={idx}
          className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
        >
          {desc}
        </p>
      ))}

      {/* Why Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Why Attend ICAN 2025?</h2>
        {data.whyAttend.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* About Helix Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Helix Conferences: Leading the Way in Event Organization</h2>
        {data.aboutHelix.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* Who Should Attend Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Neurologists and Psychiatrists
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Autism Researchers and Therapists
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Stethoscope className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Pediatricians, Educators and Caregivers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Public Health Leaders and policy makers
            </h3>
          </div>
          {/* <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <GraduationCap className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Students and trainees in dentistry and related fields</h3>
          </div> */}
        </div>
      </section>

      {/* Join Section */}
      <section className="mb-10 text-center w-full min-w-4xl px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at ICAN 2025
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      {/* <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Conference Themes</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {data.themes.map((theme, idx) => (
            <div key={idx} className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
              <theme.icon className="h-10 w-10 text-one mb-3" />
              <h3 className="text-lg font-semibold text-gray-800 mb-1">
                {theme.title}
              </h3>
              <p className="text-sm text-gray-600 text-center">
                {theme.description}
              </p>
            </div>
          ))}
        </div>
      </section> */}

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm"
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;
